import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-gold-500 selection:text-navy-900" data-id="element-158">
      <HeroSection data-id="element-159" />
      <OpeningHook data-id="element-160" />
      <ProblemSection data-id="element-161" />
      <FailedSolutions data-id="element-162" />
      <MechanismSection data-id="element-163" />
      <WhatYouGet data-id="element-164" />
      <WhoIsFor data-id="element-165" />
      <HowItWorks data-id="element-166" />
      <ProofSection data-id="element-167" />
      <FAQSection data-id="element-168" />
      <OfferSection data-id="element-169" />
      <Footer data-id="element-170" />
    </div>;
}